import publicLayoutModule from '@/store/modules/public-layout.module';
import { authService } from '../../shared/services/auth.service';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import router from '@/router';
import { i18n } from '@/iti-core-vue';
import itiLayoutMenuModule from '@/store/modules/iti-layout-menu.module';
import { ItiLanguageSelector } from '@/iti-core-vuetify';
@Component({
  components: {
    ItiLanguageSelector,
  },
})
export default class PublicFooterComponent extends Vue {
  @Prop() public title!: string;

  public goTo(path: string) {
    this.$router.push(path).catch(err => {});
    publicLayoutModule.setWebTab(path);
  }

}